import React from 'react';

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import AppCard from '../../../../../components/ui/AppCard';

const viewMainMemberTable = ({ activeUserData }) => {
  const Users = activeUserData;
  const bankAccount = Users?.bankAccount;

  return (
    <AppCard 
      className="mb-4"
      bodyClassName="p-0"
      header={
        <div className="px-6 py-4 border-b border-base-200">
          <h2 className="card-title text-center block w-full text-base-content text-lg">BANKING DETAILS</h2>
        </div>
      }
    >
      <div className="overflow-x-auto p-4">
        <table className="table w-full">
          <thead>
            <tr className="text-base-content/70">
              <th>Bank Id</th>
              <th>Account Name</th>
              <th>Account Number</th>
              <th>Type Of Account</th>
              <th>Debit Date</th>
              <th>Branch Code</th>
            </tr>
          </thead>
          <tbody>
            {bankAccount ? (
              <tr className="hover:bg-base-50 transition-colors">
                <td>{bankAccount.BankNameId}</td>
                <td>{bankAccount.Account_Name}</td>
                <td>{bankAccount.Account_Number}</td>
                <td>{bankAccount.Type_of_Account}</td>
                <td>{bankAccount.Debit_Day_FirstTimeOnly}</td>
                <td>{bankAccount.Branch_Code}</td>
              </tr>
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-8 text-base-content/50">
                  No banking details found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </AppCard>
  );
};

export default viewMainMemberTable;
